var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "radio",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4652_89921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99816 12.4436C10.4527 12.4436 12.4426 10.4537 12.4426 7.99913C12.4426 5.54454 10.4527 3.55469 7.99816 3.55469C5.54356 3.55469 3.55371 5.54454 3.55371 7.99913C3.55371 10.4537 5.54356 12.4436 7.99816 12.4436Z",
    fill: "#23273B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM14.2222 8C14.2222 11.4364 11.4364 14.2222 8 14.2222C4.56356 14.2222 1.77778 11.4364 1.77778 8C1.77778 4.56356 4.56356 1.77778 8 1.77778C11.4364 1.77778 14.2222 4.56356 14.2222 8Z",
    fill: "#23273B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4652_89921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.fbbdd07282ca3fd8d526188391aede24.svg";
export { ForwardRef as ReactComponent };